import { useNavigate } from 'react-router-dom'
import { useGetSourcesQuery } from './sourcesApiSlice'
import { memo } from 'react'
import useLang from '../../hooks/useLang'
import useTranslate from '../../hooks/useTranslate'

// import `ChakraProvider` component
import { Icon, IconButton, Tr, Td, Tooltip, Text } from '@chakra-ui/react'

// import `ChakraProvider` icon
import { CheckIcon, CloseIcon, EditIcon } from '@chakra-ui/icons'

const Source = ({ sourceId }) => {

    const { lang } = useLang()
    const { T } = useTranslate(lang)

    const { Source } = useGetSourcesQuery("sourcesList", {
        selectFromResult: ({ data }) => ({
            Source: data?.entities[sourceId]
        }),
    })

    const navigate = useNavigate()

    if (Source) {

        const handleEdit = () => navigate(`/dash/sources/${sourceId}`)

        return (
            <Tr _hover={{ color: '#333333', border: '2px', borderColor: 'teal.600' }}>
                <Td>
                    {Source.sourceStatus
                        ? <Icon as={CheckIcon} w={4} h={4} color='green.500' title={T.common.Actived} />
                        : <Icon as={CloseIcon} w={4} h={4} color='red.500' title={T.common.Disabled} />
                    }
                </Td>

                <Td>
                    <strong>{Source.sourceName}</strong>
                </Td>

                <Td>
                    {Source.sourceUrlRegex ? <Text color='green'>{Source.sourceUrlRegex}</Text> : <Text color='red'>No</Text>}
                </Td>

                <Td isNumeric>
                    <Tooltip hasArrow label={T.common.Edit} bg='gray.300' closeOnClick={true} color='black' placement='left'>
                        <IconButton
                            colorScheme='gray'
                            aria-label='New'
                            icon={<EditIcon />}
                            onClick={handleEdit}
                            _hover={{ bg: 'teal.600', color: 'white', borderColor: 'teal.600' }}
                        />
                    </Tooltip>
                </Td>
            </Tr>
        )

    } else return null
}

const memoizedSource = memo(Source)

export default memoizedSource